import styled from 'styled-components';

export const MailLogDetailContainerStyled = styled.div`
  position: relative;
  width: 92vw;
  max-width: 980px;
  max-height: 88vh;
  overflow: auto;
  padding: 1.5rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  border-radius: 8px;
  font-size: 14px;
  .modal_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
    .modal_title {
      font-size: 18px;
    }
    .close_btn {
      cursor: pointer;
      font-size: 18px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      padding: 0 4px;
    }
  }
  .empty {
    padding: 2rem;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .section {
    margin-bottom: 16px;
    .section_title {
      margin-bottom: 8px;
      color: #2b4a70;
    }
  }
  .info_row {
    display: flex;
    gap: 12px;
    padding: 6px 0;
    border-bottom: 1px solid #f0f2f5;
    .info_label {
      width: 160px;
      flex-shrink: 0;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
    }
    .info_value {
      flex: 1;
      word-break: break-all;
    }
  }
  .status_badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    background: ${({ theme }) => theme.COLORS.GRAY_1};
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .status_success {
    background: #e3f4e3;
    color: ${({ theme }) => theme.COLORS.GREEN_1};
  }
  .status_fail {
    background: #fde4e4;
    color: #c62828;
  }
  .status_sending {
    background: #fff3dc;
    color: #b26a00;
  }
  .error_box {
    margin-bottom: 16px;
    padding: 12px 14px;
    border: 1px solid #f5c2c2;
    border-radius: 6px;
    background: #fff5f5;
    .error_title {
      color: #c62828;
      margin-bottom: 4px;
    }
    .error_message {
      white-space: pre-wrap;
      word-break: break-word;
      font-size: 13px;
    }
    .error_code {
      margin-top: 6px;
      font-size: 12px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
    }
    .error_hint {
      margin-top: 8px;
      font-size: 13px;
      color: #8a4b00;
    }
  }
  .note_box {
    margin-bottom: 16px;
    padding: 10px 14px;
    border: 1px solid #dbe4f0;
    border-radius: 6px;
    background: #f7f9fc;
    color: #435466;
    font-size: 13px;
    line-height: 1.6;
  }
  .table_wrap {
    overflow-x: auto;
  }
  .item_table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    th,
    td {
      padding: 6px 8px;
      border: 1px solid #e4e8ee;
      text-align: left;
    }
    th {
      background: #f2f6fc;
      white-space: nowrap;
    }
    .right {
      text-align: right;
    }
  }
  .mail_preview {
    width: 100%;
    height: 420px;
    border: 1px solid #e4e8ee;
    border-radius: 6px;
  }
  .action_zone {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    .confirm_text {
      flex: 1;
      font-size: 13px;
    }
    .btn_box {
      width: 140px;
    }
  }
`;
